import { NavLink, Link } from "react-router-dom";

import classes from "./NavbarItem.module.css";
import { Dropdown, Menu } from "antd";

const NavbarItem = ({
  children,
  pageLink,
  onClick,
  navItem,
  isMenu,
  menuList,
  openInNewTab = false,
}) => {
  const menu = { items: menuList };
  return (
    <li className={classes.navbarItem}>
      {navItem && !isMenu && openInNewTab && (
        <Link
          to={pageLink}
          target="_blank"
          rel="noopener noreferrer"
          className={({ isActive }) => (isActive ? classes.active : undefined)}
        >
          {/* <NavLink
            onClick={onClick}
            to={pageLink}
            end
            className={({ isActive }) =>
              isActive ? classes.active : undefined
            }
          > */}
          {children}
          {/* </NavLink> */}
        </Link>
      )}
      {navItem && !isMenu && !openInNewTab && (
        <NavLink
          onClick={onClick}
          to={pageLink}
          end
          className={({ isActive }) => (isActive ? classes.active : undefined)}
        >
          {children}
        </NavLink>
      )}
      {navItem && isMenu && menuList && (
        <Dropdown
          menu={menu}
          placement="bottom"
          trigger={["hover"]}
          overlayClassName="navbar-menu"
          dropdownRender={(menu) => (
            <div className={classes.dropdownMenu}>{menu}</div>
          )}
        >
          <a
            className={classes.dropDownitems}
            onClick={(e) => e.preventDefault()}
          >
            {children}
          </a>
        </Dropdown>
      )}
      {!navItem && (
        <Link onClick={onClick} to={pageLink}>
          {children}
        </Link>
      )}
    </li>
  );
};

export default NavbarItem;
